import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { SupervisionError, InfoIssue, Supervision, Site, IssueType, SupervisionErrorStatusEnum, Flight, IssueImage, Panel, FrGeometry, SubIssue, ImageItem, ImageItemTag } from 'solar-bo';
import { MapSupervisionHelper } from '@solar/ol';
import { IIssueEditOptions } from './iissueeditoptions.interfaces';
import { EditionEnum } from 'base-models';

import { NotificationType } from 'base-models';
import { SolarBase1Component } from '@solar/solar/solar-base';
import { fabric } from 'fabric';

import { IssueEdit2KeyHandler } from './IssueEdit2KeyHandler';
import { PanelLocatorComponent } from '@solar/solar/panel/panellocator/panellocator.component';
import { IssuecanvasComponent } from '../issuecanvas/issuecanvas.component';
import { CanvasFilter } from '@solar/shared/canvasfilter.model';
import { IssueTypeHelper } from '@solar/solar/models';
import { DBG, DebugLevelEnum } from '@solar/shared/dbg.model';
import { SliderDlgComponent } from '@solar/components/sliderdlg/sliderdlg.component';

@Component({
  selector: 'app-issueedit2',
  templateUrl: './issueedit2.component.html',
  styleUrls: ['./issueedit2.component.scss']
})
export class IssueEdit2Component extends SolarBase1Component implements OnInit, OnChanges, AfterViewInit {
  issueTypeEnum = IssueType;//for use in html
  /**
 * name to identify the class
 */
  TAG = "IssueEdit2Component";
  /* 
  tareas pendientes:
    --desactivar navegacion en aplicacion principal y añadirla aqui
    --al mover un issue no se tienen datos de la imagen que solo se descargan con el gallery o imageslider
    --pintar issues existentes en la imagen actual para evitar crear donde ya existe
    --añadir boton de zoom sobre el mapa: sobre la imagen actual hará un zoom sobre el mapa hasta que podamos acceder al mapa (dailog less) 
       o quitar dialog y meter este componente en una capa sobrela vista actual
   */

  @Input() site: Site;
  supervision: Supervision;
  @Input() issue: SupervisionError;

  _lastSavedIssue: SupervisionError;
  @Input() issueList: SupervisionError[];
  @Input() flight: Flight;
  @Input() image: IssueImage;
  @Input() imageurl;
  @Input() options: IIssueEditOptions = { showIssueOnCanvas: false, openimage: true };
  @Input() gallery: any[];
  canvas_options = { zoom:1 };

  canvasFilter: CanvasFilter;
  public get imageWidth(): number {
    let value=640;
    if (this.image.info && this.image.info.image){
      value=this.image.info.image.width;
    }
    return value;
  }
  public get imageHeigth(): number {   
    let value=512;
    if (this.image.info && this.image.info.image){
      value=this.image.info.image.height;
    }
    return value;
  }


  /**
   * Event raised when an issue is saved
   */
  @Output() issueSavedEvent: EventEmitter<SupervisionError> = new EventEmitter();
  /**
   * Event raised when an image is changed by user
   */
  @Output() imageChangeEvent: EventEmitter<ImageItemTag> = new EventEmitter();

  @ViewChild('issue_canvas') issue_canvas: IssuecanvasComponent;
  @ViewChild('panellocator') panellocator: PanelLocatorComponent;

  showtemp: boolean = false;

  issuetitle: string = "Issue";
  findingIssue: boolean = false;

  editType: EditionEnum = EditionEnum.NEW;
  /**
   * panel polygon reference for finded issue
   */
  panelDrawed: any[] = [];

  /**
 * Message showed when a panel exists or similar
 */
  infomessage = "";
  /**
   * used to control buttons to show 
   */
  issueFinded: boolean = false;
  /**
   * Message to show when issue not found
   */
  issueNotFound: string = ""
  keyHandler: IssueEdit2KeyHandler;
  constructor() {
    super();

    this.loading = false;
    //this.keyHandler=new IssueEdit2KeyHandler(this);
  }
  RIGHT_ARROW = 39;
  LEFT_ARROW = 37;
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {

    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,event);

    if (event.ctrlKey == false) {
      if (event.keyCode === this.RIGHT_ARROW) {
        this.imageNext();
        event.stopPropagation();
      }
      else if (event.keyCode === this.LEFT_ARROW) {
        this.imagePrev();
        event.stopPropagation();
      }
    }
    else {
      if (event.keyCode === this.RIGHT_ARROW) {
        this.imageLast();
        event.stopPropagation();
      }
      else if (event.keyCode === this.LEFT_ARROW) {
        this.imageFirst();
        event.stopPropagation();
      }
    }
  }

  ngOnInit() {
    if (this.issue) {
      //this.issue.supervision=this.supervision;
      this.site = this.issue.supervision.site;
      this.supervision = this.issue.supervision;
      this.imageurl = MapSupervisionHelper.issueUrlImg(this.issue, this.site.id, this.supervision.id);
      this.flight = this.issue.flight;
      this.image = this.issue.image;
      //this.getImageData(this.image);
      let itemTag = new ImageItemTag();
      itemTag.flight = this.flight;
      itemTag.image = this.image;
      this.imageChangeEvent.emit(itemTag);
      let panel_pattern = Site.getPanelPattern(this.issue.supervision.site, "list");
      if (this.editType == EditionEnum.NEW) {
        this.issuetitle = "<i class='far fa-plus-square'></i> New Issue"
      }
      else {
        this.issuetitle = SupervisionError.uiLocatorByPanel(this.issue.info.panel, panel_pattern);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"IssuecanvasComponent ngOnChanges " ,changes);
    let typeChange = changes['issue'];
    if (typeChange && !typeChange.firstChange) {
    }
  }

  ngAfterViewInit() {

    if (this.issue_canvas) {
      this.canvasFilter = this.issue_canvas.canvasFilter;
      this.addRectForIssueEdition();
    }
  }
  /**Return true if issue can be saved */
  isvalid2Save() {
    if (this.issueFinded && this.issue && this.issue.info.panel) {
      return true;
    }

    return false;

  }
  getImageData(image:IssueImage){
    this.solarService.FlightImagesGetById(image.id).subscribe(
      res => {
        //image.geom_polygon = res.geom_polygon;
        //image.geom_shot = res.geom_shot;
        console.log("Actual image", this.image);
        console.log("New image", res);
        image.info=res.info;
      }
      , err => console.error(err)
    )    
  }



  
  public get zoom(): number {
    return this.issue_canvas.zoom;
  }
  public set zoom(value: number) {
    this.issue_canvas.zoom=value;
  }
  private zoomDefault: number = 1;
  zoomShowPlus: boolean = true;
  zoomShowMinus: boolean = false;
  private zoomtick = 1.5;

  public recSelection: fabric.Rect;

  zoomin(event) {
    this.zoom *= this.zoomtick;
    let canvas = this.issue_canvas.fabcanvas;
    //
    //let center_point=this.recSelection.getCenterPoint();
    //canvas.zoomToPoint(center_point, this.zoom);
    canvas.setZoom(this.zoom);
    canvas.setWidth(this.issue_canvas.fabcanvas.getWidth() * this.zoomtick);
    canvas.setHeight(this.issue_canvas.fabcanvas.getHeight() * this.zoomtick);
    this.zoomShowMinus = true;
  }
  zoomout(event) {
    if (this.zoom == 1) {
      this.zoomShowMinus = false;
      return;
    }
    this.zoom /= this.zoomtick;
    this.issue_canvas.fabcanvas.setZoom(this.zoom);
    this.issue_canvas.fabcanvas.setWidth(this.issue_canvas.fabcanvas.getWidth() / this.zoomtick);
    this.issue_canvas.fabcanvas.setHeight(this.issue_canvas.fabcanvas.getHeight() / this.zoomtick);
    if (this.zoom == 1) {
      this.zoomShowMinus = false;
    }
  }

  resetCanvas() {
    this.infomessage = "";
    this.alertmessage = "";
    this.rectCacheSave();
    let canvas = this.issue_canvas.fabcanvas;
    //this.issue_canvas.resetCanvas();
    this.issue_canvas.fabcanvas.remove(this.recSelection);
    for (let obj of this.panelDrawed) {
      //obj.set('dirty', true);
      canvas.remove(obj);
    }
    //remove marker
    this.removeIssuePanels();
    this.panelDrawed = [];
    this.issue_canvas.fabcanvas.requestRenderAll();
    this.addRectForIssueEdition();
    this.issueFinded = false;
  }

  removeIssuePanels() {
    let canvas = this.issue_canvas.fabcanvas;
    if (canvas == null) {
      return;
    }
    let removedItems = 0;
    for (let obj of canvas.getObjects()) {

      if (obj.data && obj.data.type) {
        switch (obj.data.type) {
          //case 'ISSUE_PANEL':
          case 'ISSUE_PANEL_MARKER':
            canvas.remove(obj);
            removedItems += 1;
        }
      }
    }
    if (removedItems > 0) {
      canvas.requestRenderAll();
    }
  }
  /**
   * No usar, mantenemos el ultimo
   */
  private rectCacheSave() {
    if (this.recSelection) {
      let bounding = this.recSelection.getBoundingRect(false, true);
      const rect = new fabric.Rect({
        left: 0,
        top: 0,
        fill: 'blue',
        width: 0,
        height: 0,
        opacity: 0.4
      });
      //let angle = this.recSelection.angle;/2conf
      rect.left = bounding.left;
      rect.top = bounding.top;
      rect.width = bounding.width;
      rect.height = bounding.height;
      //rect.angle = angle;/2conf
      //this.recSelection = null;
      //this.recSelection = rect;
    }
  }
  addRectForIssueEdition() {
    if (this.recSelection) {
      this.issue_canvas.add(this.recSelection);
      return;
    }
    let canvas = this.issue_canvas.canvas;
    let width = Math.ceil(canvas.nativeElement.width / 9);
    let height = Math.ceil(canvas.nativeElement.height / 11);
    let top = Math.ceil(canvas.nativeElement.height / 2) - height;
    let left = Math.ceil(canvas.nativeElement.width / 2) - width;
    let rect = new fabric.Rect({
      left: left,
      top: top,
      fill: 'blue',
      width: width,
      height: height,
      opacity: 0.4,
      hoverCursor: "move"
    });

    rect.on('selected', function (options) {
      DBG.log(DebugLevelEnum.VERBOSE,this.TAG,'selected a rectangle', options);
    });

    this.recSelection = rect;
    this.issue_canvas.add(this.recSelection);
  }

  filterBtnToggle($event) {
    let btn = $event.currentTarget;
    btn.classList.toggle("btn-outline-secondary");
    btn.classList.toggle("btn-secondary");
  }

  filtergrayscale($event) {
    this.canvasFilter.filtergrayscale($event);
  }
  filterInvert($event) {
    this.canvasFilter.filterInvert($event);
  }
  /**
   * Opne modal component
   * @param dialog 
   * @param issue 
   * @param supervision 
   * @param options 
   */
  public static openModal(dialog: MatDialog, issue: SupervisionError, supervision: Supervision, options: any): MatDialogRef<IssueEdit2Component> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "1114px";
    //dialogConfig.height = "90%";
    //dialogConfig.minHeight = "8";
    dialogConfig.position = { left: '10px', top: '200' };
    dialogConfig.backdropClass = "material-dialog-clickable-backdrop-class"
    dialogConfig.closeOnNavigation = true;
    //dialogConfig.data = {entity2edit: entity2edit };

    let dialogRef: MatDialogRef<IssueEdit2Component>;
    dialogRef = dialog.open(IssueEdit2Component, dialogConfig);
    dialogRef.componentInstance.supervision = supervision;
    dialogRef.componentInstance.issue = issue;
    dialogRef.componentInstance.options = options;

    return dialogRef;
  }
  /**
   * Show the description of an issue 
   * @param issue 
   */
  ui_errortype(issue) {
    return IssueTypeHelper.issueGetErrorTypeDescription(issue.type);
  }

  ui_relevance(issue) {
    if (!issue) {
      return "";
    }

    if (issue.info) {
      return issue.info.relevance;
    }
  }

  uiurlimg(issue: SupervisionError): string {
    return MapSupervisionHelper.issueUrlImg(issue, this.site.id, issue.supervision.id);
  }

  /**
   * user select the error type 
   * @param item 
   * @param newType 
   */
  issueChangeError(item: SupervisionError, newType: IssueType) {
    this.issue.type = newType;
  }
  ui_btn_errortype_class(row, errorType: IssueType) {
    if (!row) {
      return "";
    }
    if (row.type === errorType) {
      return "btn-success text-white";
    }
  }
  /**
   * to show the locator in lists
   * @param issue 
   */
  uiLocator(issue: SupervisionError) {
    let panelPatternList = Site.getPanelPattern(this.supervision.site, "list");
    return SupervisionError.uiLocator(issue, panelPatternList);
  }



  /**
   * Find issue on selected area
   * @param onArea if true search only selected area
   */
  findissue_click(onArea: boolean = true) {
    try {
      this.infomessage = "";
      this.loading = true;
      this.alertmessage = "";
      this.issueFinded = false;
      this.resetCanvas();
      this.findingIssue = true;

      let issueDTOCopy = new SupervisionError();
      issueDTOCopy.id = this.issue.id;
      issueDTOCopy.id_supervision = this.supervision.id;
      issueDTOCopy.id_supervision_flight = this.flight.id;
      issueDTOCopy.id_supervision_image = this.image.id;

      issueDTOCopy.info = new InfoIssue();
      if (onArea == false) {
        issueDTOCopy.info['detect_panel'] = false;
      }
      issueDTOCopy.info.errors = [];

      let subissue: SubIssue = new SubIssue;
      subissue.type = this.issue.type;
      subissue.geometry = this.convertCanvasCoordsToCoordsArray(this.recSelection.aCoords);
      //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,subissue.geometry);
      issueDTOCopy.info.errors.push(subissue);


      //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,JSON.stringify(issueDTOCopy));

      this.solarService.supervisionIssueFind(issueDTOCopy)
        .subscribe(
          res_issue_finded => this.findIssueHandleresult(this.issue, res_issue_finded)
          , err => this.findissueHandleError(err)
        );
    }
    catch (err) {
      this.handleError(err, "Error finding issue ");
    }
  }

  private convertCanvasCoordsToCoordsArray(coords: any) {

    let g: FrGeometry = new FrGeometry();
    let scaleX=this.issue_canvas.scaleX;
    let scaleY=this.issue_canvas.scaleY;
    let c: any[] = [];
    c.push([coords.tl.x / scaleX, coords.tl.y / scaleY]);
    c.push([coords.tr.x / scaleX, coords.tr.y / scaleY]);
    c.push([coords.br.x / scaleX, coords.br.y / scaleY]);
    c.push([coords.bl.x / scaleX, coords.bl.y / scaleY]);
    c.push([coords.tl.x / scaleX, coords.tl.y / scaleY]);//first point again

    let firstArray = [];
    firstArray.push(c);

    g.coordinates = [];
    g.coordinates.push(c);
    console.log("Coords to find",g);
    return g;
  }

  private findissueHandleError<T>(err: any) {
    this.findingIssue = false;
    this.loading = false;
    this.issueFinded = false;
    this.handleError(err, "Error finding issue ");
  }

  private async findIssueHandleresult(issue, issuesFinded: SupervisionError[]) {
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,'findIssueHandleresult', issuesFinded);
    this.findingIssue = false;
    try {
      this.listerrmessage = '';
      this.loading = false;

      if (!issuesFinded || issuesFinded.length == 0) {
        this.issueFinded = false;
        this.issueNotFound = "Sorry, system can not detect nothing on selected area."
        return;
      }
      let issueFinded: SupervisionError = issuesFinded[0];
      //buscamos si ya existe ese panel con issues
      let existIssue: SupervisionError = this.issueList.find(elem => elem.info.panel.id === issueFinded.info.panel.id);
      if (existIssue) {
        this.infomessage = '<div class="alert alert-warning alert-with-icon"><i class="alert-icon fas fa-exclamation-triangle"></i>This issue exist.</div>';
      }

      issueFinded.info.panel = await this.solarService.siteGetPanelById(issueFinded.info.panel.id);//issueFinded no contiene los datos completos del panel
      issueFinded.supervision = this.supervision;

      //this.issue_canvas.resetCanvas();
      this.issue_canvas.fabcanvas.remove(this.recSelection);
      this.issue = issueFinded;
      this.panelDrawed = [];
      this.panelDrawed = this.panelDrawed.concat(this.issue_canvas.draw_issue_panel_on_image(issueFinded, true));
      if (issueFinded.info && issueFinded.info.errors && issueFinded.info.errors.length > 0) {
        this.panelDrawed.push(this.issue_canvas.draw_subissue_on_image(issueFinded.info.errors[0]));
      }
      this.issueFinded = true;
    }
    catch (err) {
      this.showerror("Error finding issue.", err);
    }

  }
  /**
   * show message when issue exist
   * @param issueFinded 
   */
  private configureInfoExist(issueFinded: SupervisionError) {
    let panel = issueFinded.info.panel;
    if (panel) {
      let existIssue: SupervisionError = this.issueList.find(elem => elem.info.panel.id === panel.id);
      if (existIssue) {
        this.infomessage = '<div class="alert alert-warning alert-with-icon"><i class="alert-icon fas fa-exclamation-triangle"></i>This issue exist.</div>';
      }
      else {
        this.infomessage = null;
      }
    }
    else {
      this.infomessage = null;
    }

  }
  /**
   * used by ui
   * @param issue 
   */
  async confirmIssue_click() {
    try {
      let panel: Panel = await this.panellocator.getSelectedPanel();
      if (panel == null) {
        this.infomessage = '<div class="alert alert-danger alert-with-icon"><i class="alert-icon fas fa-exclamation-triangle"></i>No panel selected</div>';
        return;
      }
      //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"saved", this.issue);
      if (this._lastSavedIssue == null || this._lastSavedIssue.info.panel.id != this.issue.info.panel.id) {
        this.saveIssue(this.issue);
      }
      else {
        this.infomessage = '<div class="alert alert-danger alert-with-icon"><i class="alert-icon fas fa-exclamation-triangle"></i>You are trying to save last issue saved.</div>';
        return;
      }

    }
    catch (err) {
      this.notifyerror(err, "Error saving issue for panel: ");
    }
  }
  saveIssue(issue: SupervisionError) {
    this.submitted = true;
    this.listerrmessage = "";
    this.alertmessage = null;
    this.loading = true;

    issue.info.status = SupervisionErrorStatusEnum.validated;

    this.solarService.supervisionIssueUpdate(this.issue)
      .subscribe(
        issueSavedResult => this.saveIssueHandleresult(issue, issueSavedResult)
        , err => this.saveIssueHandleError(err)
      );
  }

  saveIssueHandleError<T>(err: any) {
    this.loading = false;
    this.submitted = false;
    this.handleError(err, "Error updating issue ");
  }

  saveIssueHandleresult(issue, issueSaved: SupervisionError) {
    this._lastSavedIssue = issueSaved;

    DBG.log(DebugLevelEnum.VERBOSE,this.TAG,'saveIssueHandleresult', issueSaved);
    this.listerrmessage = '';
    this.loading = false;
    this.submitted = false;
    //como el servidor devuelve el issue con datos simples hay que asignar algunos datos
    issueSaved.supervision = this.supervision;
    issueSaved.info.panel = issue.info.panel;
    issueSaved.flight = this.flight;
    issueSaved.image = this.image;
    this.showNotification(NotificationType.Success, "Issue saved");
    this.issueSavedEvent.emit(issueSaved);
    this.resetCanvas();
    this.issue_canvas.removeIssuePanels();
    this.issue_canvas.drawIssuesByImage(this.image.id);
    this.issue_canvas.fabcanvas.requestRenderAll();

    //todo: añadir a la lista de la supervision y completar con la información necesaria  
  }

  private copyIssue() {
    let issueDTOCopy: SupervisionError = new SupervisionError();
    issueDTOCopy.id = this.issue.id;
    issueDTOCopy.type = this.issue.type;
    issueDTOCopy.info = new InfoIssue();
    issueDTOCopy.info.status = SupervisionErrorStatusEnum.validated;
    issueDTOCopy.info.statusType = this.issue.info.statusType;
    issueDTOCopy.info.errorTypePrev = this.issue.info.errorTypePrev;
    issueDTOCopy.info.updated_by = this.globService.currentUserValue.id;
    issueDTOCopy.info.validatedby = this.globService.currentUserValue.id;
    issueDTOCopy.info.validation_date = new Date();
    return issueDTOCopy;
  }

  /**
   * message to show to user when no panel is found by panel locator component
   */
  panelMessage: string = "";
  panellocator_panelChangeEvent_handler($event) {
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"panellocator_panelChangeEvent_handler", $event);
    let panel = $event;
    if (panel == null) {
      this.panelMessage = "No panel found";
      this.issue.info.panel = null;
    }
    else {
      //mmmm
      this.panelMessage = "";
      this.issue.info.panel = panel;
    }
    this.configureInfoExist(this.issue);
  }

  /**
   * gallery images count
   */
  galleryCount = 0;
  gallerySelectedIndex: number = 0;
  configComponent() {

    if (this.gallery) {
      this.galleryCount = this.gallery.length;
      this.gallerySelectedIndex = this.getImageIndex(this.image);
    }
  }
  imageNext(event?: any) {
    let idx = this.gallerySelectedIndex + 1;
    this.gotoGalleryIndex(idx);
  }
  imagePrev(event?: any) {
    let idx = this.gallerySelectedIndex - 1;
    this.gotoGalleryIndex(idx);
  }

  imageFirst(event?: any) {
    this.gotoGalleryIndex(0);
  }
  imageLast(event?: any) {
    let idx = this.galleryCount - 1;
    this.gotoGalleryIndex(idx);
  }
  private gotoGalleryIndex(idx) {
    if (idx > -1 && idx <= this.galleryCount && this.galleryCount > 0) {
      let data: ImageItem = this.gallery[idx];
      this.resetCanvas();
      this.issue_canvas.removeIssuePanels();
      this.image = data.tag.image;
      this.flight = data.tag.flight;
      this.imageurl = MapSupervisionHelper.FlightImageUrlByFullFields(this.image.name, this.site.id, this.supervision.id, this.flight.id);

      this.gallerySelectedIndex = idx;

      let itemTag = new ImageItemTag();
      itemTag.flight = this.flight;
      itemTag.image = this.image;

      this.issue_canvas.drawIssuesByImage(this.image.id);
      this.issue_canvas.fabcanvas.requestRenderAll();

      //this.imageChangeEvent.emit(itemTag);
    }
  }
  private getImageIndex(image: IssueImage) {
    let list = this.gallery;
    if (!list) {
      return -1;
    }
    let index = list.findIndex(item => item.id === image.id);
    return index;
  }

  adjustTemperature(event){
    let dialogData = {
      title: "Adjust Temperature image"
      , titlesub: ""
      , slider_step: 1
      , slider_max: 100
      , slider_min: 0
      , range_title: "Adjust temperature values"
      , rangeValues: [0,100]
    };
    this.solarService.FlightImagesGetById(this.image.id)
    .subscribe(
      image_data => {
        if (image_data.info && image_data.info.stats){
          dialogData.slider_min=image_data.info.stats.min;
          dialogData.slider_max=image_data.info.stats.max;
          if (image_data.info.stats["adjusted"]){
            dialogData.rangeValues=[ image_data.info.stats["adjusted"].min,image_data.info.stats["adjusted"].max];
          }else{
            dialogData.rangeValues=[ image_data.info.stats.min,image_data.info.stats.max];
          }
          
        }
        let dialogRef: MatDialogRef<SliderDlgComponent>;
        dialogRef = SliderDlgComponent.openModal(this.dialog, dialogData,"400px");
        dialogRef.componentInstance.selectedEvent.subscribe(res => {
          this.adjustTemperatureAction(dialogRef,res);
        });        
      }
      , err => this.handleError(err)
    );


  }

  private adjustTemperatureAction(dialogRef: MatDialogRef<SliderDlgComponent>,res:{min,max}){
    dialogRef.close();
    let payload={low:res.min,high:res.max};
    this.solarService.image_rgb_adjust(this.image.id,payload)
    .subscribe(
      reslist => {
        this.issue_canvas.reloadLoadBackground();
        this.showNotification(NotificationType.Info, "Image temperature changed. Please note that in this version images can be served by cache and not reflect image changes.");
      }
      , err => this.handleError(err)
    );
  }

}

